import {
  PDCA_SET_BASE_CONTEXTO,
  PDCA_SET_BASE_CONTEXTO_LOADING,
  PDCA_SET_BASE_CONTEXTO_ERRO,
  PDCA_RESET_BASE_CONTEXTO,
  PDCA_SET_BASE_ERRO,
  PDCA_SET_BASE_LOAD,
  PDCA_SET_PERIODO
} from './pdcaBaseActions'

const initialState = {
  projetoId: null,
  empresaPdcaExiste: false,
  empresaPdcaId: 0,
  empresaPdcaNome: '',
  projetoNome: '',
  loadingContexto: false,
  erroContexto: null,
  contextoCarregado: false,
  dataInicial: '',
  dataFinal: '',
  erro: {},
  load: {}
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PDCA_SET_BASE_CONTEXTO_LOADING:
      return {
        ...state,
        loadingContexto: payload
      }

    case PDCA_SET_BASE_CONTEXTO_ERRO:
      return {
        ...state,
        erroContexto: payload
      }

    case PDCA_SET_BASE_CONTEXTO:
      return {
        ...state,
        projetoId: payload.projetoId,
        empresaPdcaExiste: payload.empresaPdcaExiste,
        empresaPdcaId: payload.empresaPdcaId,
        empresaPdcaNome: payload.empresaPdcaNome,
        projetoNome: payload.projetoNome,
        loadingContexto: false,
        erroContexto: null,
        contextoCarregado: true
      }

    case PDCA_SET_PERIODO:
      return {
        ...state,
        dataInicial: payload.dataInicial,
        dataFinal: payload.dataFinal
      }

    case PDCA_RESET_BASE_CONTEXTO:
      return {
        ...initialState
      }

    case PDCA_SET_BASE_ERRO:
      return {
        ...state,
        erro: payload
      }

    case PDCA_SET_BASE_LOAD:
      return {
        ...state,
        load: {
          [payload.name]: payload.value
        }
      }

    default:
      return state
  }
}